module.exports = __webpack_public_path__ + "img/item_origem.f265d115.svg";